import get from 'lodash/get';
import { logError } from 'utils/logger';
import { mapConditionsToCriteria } from 'modules/jsonRulesCriterias/businessCriteria';
import { AftermarketProduct } from '@trnsact/trnsact-shared-types';
import { Configuration, ProductConfig } from 'modules/aftermarket';
import { PartnerLink } from '@trnsact/trnsact-shared-types/src/generated';
import { MARKUP_TYPE } from '@trnsact/business-criteria/dist/src/models/rule-event/aftermarket/markup-type';

export class AftermarketProductManagementHelpers {
  static getPartnerLinkLabel(partnerLink: PartnerLink): string {
    // TODO: I understand this is silly, we should use account name instead.
    //       Account name is currently not available. We should add it to the
    //       return value from the API.
    if (partnerLink?.name) {
      return partnerLink.name;
    }
    return 'Partner Vendor';
  }
}

export function mapProductConfigToListing(product: AftermarketProduct): ProductConfig[] {
  if (!Array.isArray(product?.criteria)) return [];

  try {
    return product.criteria.map((criteria: any) => {
      const {
        event: { params },
        conditions: { formRules = [] },
      } = criteria;

      const mappedRulesValueByFact = mapConditionsToCriteria(formRules).reduce(
        (acc, rule) => {
          acc[rule.fact] = rule;
          return acc;
        },
        {} as Record<string, any>
      );

      return {
        cost: {
          value: params.RATEFACTOR > 0 ? params.RATEFACTOR : params.DEALERCOST,
          isUseRateFactor: params.RATEFACTOR > 0,
        },
        markup: {
          value: params.MARKUP.AMOUNT ?? 0,
          type: params.MARKUP.TYPE ?? MARKUP_TYPE.PERCENTAGE,
        },
        criteria: mappedRulesValueByFact,
        pricing: {
          min: params.PRICINGMIN ?? 0,
          max: params.PRICINGMAX ?? 0,
        },
        retailPrice: params.SUGGESTEDRETAILPRICE ?? 0,
      };
    });
  } catch (error) {
    logError(error);
    return [];
  }
}

export function getInitialConfigKeysFromCriteria(criteriaList: AftermarketProduct['criteria'][]) {
  const keys = new Set<string>();

  criteriaList.forEach(criteria => {
    const formRules = get(criteria, 'conditions.formRules', []);

    formRules.forEach((rule: any) => {
      if (typeof rule.fact === 'string') {
        keys.add(rule.fact);
      }
    });
  });

  return Array.from(keys);
}

export function mapListingToConfiguration(input: ProductConfig, index: number): Configuration {
  return {
    name: !index ? 'Base Configuration' : `Configuration ${index}`,
    minPricing: input.pricing.min,
    maxPricing: input.pricing.max,
    dealerMarkup: input.markup.value,
    dealerMarkupType: input.markup.type,
    suggestedRetailPricing: input?.retailPrice ?? 0,
    rateFactor: input.cost.isUseRateFactor ? input.cost.value : 0,
    dealerCost: input.cost.isUseRateFactor ? 0 : input.cost.value,
    configRows: Object.entries(input?.criteria ?? {}).map(([fact, value]: any) => ({ fact, ...value })),
  };
}
